import List from "./List";
import Edit from "./Edit";
import Create from "./Create";

export const UserList = List;
export const UserEdit = Edit;
export const UserCreate = Create;
